'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;let

FleetInsightConfig=class FleetInsightConfig{
static get $inject(){return['$stateProvider','$urlMatcherFactoryProvider']}

constructor($stateProvider,$urlMatcherFactoryProvider){
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('fleetInsight',{
url:'/fleetInsight?interval&groupId&{fleetInsightMainTabSelection:int}&{fatigueTrendsTabSelection:int}',
reloadOnSearch:!1});

$stateProvider.state(feature.fullName,feature.config);
}};


module.exports=FleetInsightConfig;
//# sourceMappingURL=fleetInsightConfig.js.map
